module.exports = __webpack_public_path__ + "img/hip-endo-mesomorph-male.be6ca381.svg";